import { newToolFilterOAuthMcp } from "../oauth.ts";

export const wordpressMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://s1.wp.com/i/webclip.png",
  url: "https://public-api.wordpress.com/wpcom/v2/mcp/v1",
  label: "WordPress.com",
});
